// ServicesDesignData.js
export const ServDesignTopTxt = [
  {
    id: 1,
    // image: require('../images/ServiceImg/Design/ServDesignTouch.jpg'),
    // alt: 'images/ServiceImg/Design/ServDesignTouch.jpg',
    name: 'Design PCap Capacitive Touch Panel',
    title: '設計 PCap 電容式觸控面板',
    subtitle: '',
    text:
      '设计先进的触控产品，以在恶劣的专业环境中实现最佳性能，同时满足或超越法规遵循和质量保证。\n' +
      'HLZ在中国和亚州的专业工程、设计和制造团队拥有精良的装备，能够实现公司多品种、' +
      '小批量生产和快速成型的能力。确保产品符合高可靠性应用所需的严格质量要求。\n' +
      '我们致力于打造业界可靠的产品，符合严格的ISO9001 & TS16949 & ISO13485认证\n' +
      '\n',
    nameEng: '',
    titleEng: '',
    subtitleEng: '',
    textEng:
      '\n',
    describe: 'ServDesignTop',
    time: '2025/12/12',
  },
]

export const ServDesignPCapImg = [
  {
    id: 1,
    image: require('../images/ServiceImg/DesignTouch/CoverGlassDesignA.png'),
    alt: 'images/ServiceImg/DesignTouch/CoverGlassDesignA.png',
  },
  {
    id: 2,
    image: require('../images/ServiceImg/DesignTouch/CoverGlassDesignB.png'),
    alt: 'images/ServiceImg/DesignTouch/CoverGlassDesignB.png',
  },
  {
    id: 3,
    image: require('../images/ServiceImg/DesignTouch/CtpStructure.png'),
    alt: 'images/ServiceImg/DesignTouch/CtpStructure.png',
  },
  {
    id: 4,
    image: require('../images/ServiceImg/DesignTouch/DITOGlassSensor.png'),
    alt: 'images/ServiceImg/DesignTouch/DITOGlassSensor.png',
  },
  {
    id: 5,
    image: require('../images/ServiceImg/DesignTouch/FilmSensorOverview.png'),
    alt: 'images/ServiceImg/DesignTouch/FilmSensorOverview.png',
  },
  {
    id: 6,
    image: require('../images/ServiceImg/DesignTouch/FilmSensorStructure.png'),
    alt: 'images/ServiceImg/DesignTouch/FilmSensorStructure.png',
  },
  {
    id: 7,
    image: require('../images/ServiceImg/DesignTouch/FlimSensorIntroduction.png'),
    alt: 'images/ServiceImg/DesignTouch/FlimSensorIntroduction.png',
  },
  {
    id: 8,
    image: require('../images/ServiceImg/DesignTouch/FunctionTestPc.png'),
    alt: 'images/ServiceImg/DesignTouch/FunctionTestPc.png',
  },
  {
    id: 9,
    image: require('../images/ServiceImg/DesignTouch/HowPCapTouchWorksA.png'),
    alt: 'images/ServiceImg/DesignTouch/HowPCapTouchWorksA.png',
  },
  {
    id: 10,
    image: require('../images/ServiceImg/DesignTouch/HowPCapTouchWorksB.png'),
    alt: 'images/ServiceImg/DesignTouch/HowPCapTouchWorksB.png',
  },
  {
    id: 11,
    image: require('../images/ServiceImg/DesignTouch/SensorOcaAttachA.png'),
    alt: 'images/ServiceImg/DesignTouch/SensorOcaAttachA.png',
  },
  {
    id: 12,
    image: require('../images/ServiceImg/DesignTouch/SensorOcaAttachB.png'),
    alt: 'images/ServiceImg/DesignTouch/SensorOcaAttachB.png',
  },
  {
    id: 13,
    image: require('../images/ServiceImg/DesignTouch/SensorOcaAttachC.png'),
    alt: 'images/ServiceImg/DesignTouch/SensorOcaAttachC.png',
  },
  {
    id: 14,
    image: require('../images/ServiceImg/DesignTouch/SensorOcaAttachD.png'),
    alt: 'images/ServiceImg/DesignTouch/SensorOcaAttachD.png',
  },
  {
    id: 15,
    image: require('../images/ServiceImg/DesignTouch/SensorThicknessDesign.png'),
    alt: 'images/ServiceImg/DesignTouch/SensorThicknessDesign.png',
  },
  {
    id: 16,
    image: require('../images/ServiceImg/DesignTouch/TouchThicknessDesign.png'),
    alt: 'images/ServiceImg/DesignTouch/TouchThicknessDesign.png',
    // link: 'https://xxxxxx.com/design/xxxxxx',
  },
]

export const ServDesignPCapTxt = [
  // {
  //   id: 0,
  // image: require(''),
  // alt: 'images/ServiceImg/Design/ServDesignTouch.jpg',
  // name: 'Services / PCap Design',
  // title: 'Services / PCap Design',
  // subtitle: '设计\n',
  // text: '' +
  //   '设计先进的触控产品，以在恶劣的专业环境中实现最佳性能，同时满足或超越法规遵循和质量保证。HLZ在中国和亚州的专业工程、\n' +
  //   ' 设计和制造团队拥有精良的装备，能够实现公司多品种、小批量生产和快速成型的能力。此外，我们的设施拥有10,000级无尘室，\n' +
  //   ' 确保产品符合高可靠性应用所需的严格质量要求。我们致力于打造业界可靠的产品，符合严格的ISO9001和ISOxxxxxx标准\n' +
  //   ' ',
  // nameEng: 'Aerospace Touch Screen Display Solutions',
  // titleEng: 'Aerospace Touch Screen Display Solutions',
  // subtitleEng: 'Touchscreen Solutions for High-Reliability Applications',
  // textEng:
  //   '１.Sensor Design\n' +
  //   'If your industrial LCD display faces rough environmental conditions, your LCD design must prioritize coverglass protection and ruggedization.\n' +
  //   '\n' +
  //   '２.Sensor Glass Features:\n' +
  //   '     • Chemically-Strengthened\n' +
  //   '     • Ruggedized\n' +
  //   '\n' +
  //   ' ',
  //   describe: 'ServDesignPCap',
  //   time: '2025/8/10',
  // },
  {
    id: 1,
    // image: require(''),
    alt: 'images/ServiceImg/Design/ServDesignTouch.jpg',
    name: '１.PCap Touch Panel Design(投射电容式触摸屏设计)',
    title: '投射电容式触摸屏设计',
    // title: '投射电容式触摸屏设计(PCap Touch Panel Design)',
    subtitle: '投射电容触摸屏设计',
    text:
      '１.投射电容触摸屏结构(PCap Touch Structure)由多层组成，关键组件包括：\n' +
      '      ※盖板：\n' +
      '           PC、PET、PMMA盖板 & 玻璃盖板\n' +
      '      ※光学胶：\n' +
      '          连接盖板与功能片\n' +
      '      ※功能片(位盖板与功能片之间）\n' +
      '          ★ 上层电极层(X Grid: ITO Pattern + Silver Trace)\n' +
      '          ★ 玻璃基板\n' +
      '          ★ 下层电极层(Y Grid: ITO Pattern + Silver Trace)\n' +
      '          ★ 软性线路板(FPCA)或印刷线路板(PCBA) + 控制芯片。\n' +
      '\n' +
      '２.PCap触摸屏如何运作(How PCap Touch Works)\n' +
      '      ※投射电容感应原理(PCap Touch Theory)：\n' +
      '          ★ 电极会不断产生微小的静电场。当手指(或触控笔等)靠近或触摸表面时，\n' +
      '              会引起局部静电场的变化，因为人体可以导电并改变电容\n' +
      '          ★ 电容是电气在电场中储存能量的特性，屏幕透过检测电容的变化来运作\n' +
      '          ★ 每次触摸都会引起接触点处可测量的电容变化，控制器会侦测到其变化，\n' +
      '              并透过比较来自电网的讯号来精确定位触控的位置\n' +
      '      ※投射电容方式\n' +
      '          ★ 在PCap系统中，来自电极的电场「投射」到表面之外，即使未直接接触\n' +
      '              (例如透过手套或薄表面)，也可以检测到触摸\n' +
      '          ★ 交叉点都充当独立的传感器，因此系统可以侦测多个触控点\n' +
      '      ※多点触控\n' +
      '          ★ PCap能够进行多点触控侦测，因为它可以同时追踪多个点的电容变化\n' +
      '          ★ 这是透过感应整个电极网格的变化并根据讯号强度和模式区分不同的\n' +
      '              触摸来实现的\n' +
      '      ※互电容\n' +
      '          ★ 与自电容测量不同，对于给定的相互传感器布局，没有简单的方法\n' +
      '              来近似预期的触控电容\n' +
      '      ※使用者的触摸接触主要由电极对和指尖之间的边缘场和点场决定\n' +
      '      ※在设计互电容功能片时，可以优化节点布局以满足应用要求，\n' +
      '          如：最大灵敏度、最佳噪音容忍度、最佳防水效果、最小预设功能片电容、\n' +
      '                  最低功耗、最小触控延迟\n' +
      '      ※所有应用程序都需要在这些属性之间做权衡，因为实现一个属性\n' +
      '          就意味着要损害其他属性。如使用高交错电极可达到最强的灵敏度。\n' +
      '          然而，要实现最小功能片电容，需要X和Y之间有更大的间距。\n' +
      '          增加X-Y分离会减少预设的X-Y电容，但也会减少电极之间平行段的长度\n' +
      '\n' +
      '３.投射电容式触摸屏的优点：\n' +
      '      ※耐用性：即使表面有刮痕或脏污仍能运作\n' +
      '      ※多点触摸：允许捏合缩放、旋转等手势\n' +
      '      ※反应速度快：提供快速、精确的触控反应\n' +
      '      ※无需校准：在各种环境下都能保持长期稳定\n' +
      '      ※抗污垢碎屑：無懼污垢碎屑侵擾\n' +
      '      ※透光率高：\n' +
      '      ※防水防潮：\n' +
      '      ※靈活適配：\n' +
      '      ※手套觸控：\n' +
      '      ※多模觸控模式：\n' +
      ' ',
    describe: 'ServDesignSensor',
    link: '',
    time: '2025/2/18',
  },
  {
    id: 2,
    // image: require(''),
    alt: 'images/ServiceImg/Design/ServDesignTouch.jpg',
    name: '２.Cover Lens Design(设计Glass Cover / Plastic Cover)',
    title: '装饰保护盖板设计',
    subtitle: '玻璃 / 塑胶保护盖板设计',
    // subtitle: 'Glass Cover / Plastic Cover设计',
    text:
      '\n' +
      '触摸屏(TP)面临恶劣的环境条件，整体模块设计优先考虑盖板玻璃的保护和加固\n' +
      '１.玻璃保护盖板(Glass Cover Lens)：\n' +
      '     概述：玻璃保护盖板又称玻璃防护屏，主要用于触控显示单元，\n' +
      '                 能保护触控感应器和显示面板等精密电子元器件\n' +
      '     ※尺寸设计：OD、AA、VA设计\n' +
      '     ※玻璃厚度：玻璃基材厚度，一般为0.55、15mm\n' +
      '     ※材质：钠钙、旭硝子、南玻、彩虹、康宁\n' +
      '     ※网板印刷：\n' +
      '         ★ 图形与颜色：边缘遮盖必须盖住Sensor银线，且大于LCM AA单边0.2mm\n' +
      '         ★ 图形与字符：玻璃保护盖板上的图形与字符多种多样，\n' +
      '             主要包括以下几类：品牌logo、认证标志、功能与提示图形字符、\n' +
      '             装饰性图形字符、特殊用途图形字符\n' +
      '         ★ 膜层厚度：印刷必须2~3次，以避免针孔，印刷总厚度小于15um\n' +
      '     ※玻璃强化：\n' +
      '         ★ 化学钢化：防刮达到6~9H\n' +
      '         ★ 物理钢化：防刮达到6~9H\n' +
      '         ★ 翘曲度：翘曲度是衡量物体平面度变化的一个指标，指玻璃保护盖板在\n' +
      '             平面上的弯曲程度，通常用盖板对角线或边缘的最大变形量与\n' +
      '             对角线长度或边缘长度的比值来表示\n' +
      '     ※表面处理：\n' +
      '         ★AG、AR、AF\n' +
      '     ※厚度设计：\n' +
      '         ★搭配整体机构考量 0.4、0.55、0.7、1.1、1.6、1.8、2.0、3.0mm\n' +
      '     ※应用领域：\n' +
      '         ★消费电子、车载、航空、军工、人工智能、楼宇对讲、医疗\n' +
      '\n' +
      '２.复合保护盖板(PMMA+PC)：\n' +
      '     ※性能特点：\n' +
      '         ★透光性极佳(90%+，接近玻璃)\n' +
      '         ★耐候性强，抗紫外线老化\n' +
      '         ★重量轻(密度 1.19g/cm³)\n' +
      '         ★易加工(切割、抛光等)\n' +
      '         ★成本较低\n' +
      '    ※尺寸设计：OD、AA、VA设计\n' +
      '         ★边缘遮盖必须盖住Sensor银线，且大于LCM AA单边0.2mm\n' +
      '    ※厚度设计：\n' +
      '         ★取决于复合板材厚度，一般为1.0、2.0mm\n' +
      '    ※材质要求：\n' +
      '         ★PMMA+PC 2层结构、PMMA+PC+PMMA 3层结构\n' +
      ' '
  },
  {
    id: 3,
    // '３.	PCap Sensor Design(PCap功能片設計)\n' +
    // image: require(''),
    alt: 'images/ServiceImg/Design/ServDesignTouch.jpg',
    name: '３.PCap Sensor Design(PCap功能片設計)',
    title: '投射电容功能片設計(PCap Sensor Design)',
    subtitle: 'DITO功能片 / GFF功能片设计',
    text:
      '１.DITO Glass功能片設計\n' +
      '     ※PCap 功能片原理\n' +
      '        分自容與互容感應方式两大类，自容使用單層感應，互容？？？\n' +
      '     ※ITO Pattern(ITO 圖形)：\n' +
      '         DITO包含上下(X/Y)双层，SITO只有单层，图形可为Diamond、Bar ring等，\n' +
      '         感应层宽度手指点击宽度最大不超过8mm\n' +
      '     ※通道数：\n' +
      '         依据触摸屏的应用场景、尺寸、分辨率以及所采用的触控芯片等不同因素。\n' +
      '         通道数越多，通常能实现更高的分辨率和更精准的触控定位，\n' +
      '         同时也能支持更多点的触控检测\n' +
      '     ※导通线路：\n' +
      '         连接线路分为银导通线路及金属导通线路\n' +
      '     ※绝缘层(边缘线路保护)：\n' +
      '         导线线路容易刮伤覆盖绝缘保护，必须考虑膜厚影响盖板贴合\n' +
      '     ※ITO X/Y Grid连接點：\n' +
      '         投射电容触摸屏中，ITO(氧化铟锡)接点是用于连接触摸屏的感应线路与\n' +
      '         外部电路或FPC(软性线路板)等的连接点，常见的有直接与感应电极\n' +
      '         相连的接点，用于传输电信号以实现触控感应功能，还有与驱动芯片或\n' +
      '         控制电路连接的接点，以实现对触摸屏的控制和数据传输\n' +
      '     ※FPC接点(FPC Bonding Pad)：\n' +
      '         投射电容触摸屏中FPCa(软性线路板)与功能片X/Y Grid部件连接的部位\n' +
      '     ※ITO消影(ITO Index Matching)：\n' +
      '         通过特定的技术和工艺处理，减少或消除触摸屏上因氧化铟锡(ITO)线路\n' +
      '         引起的视觉上的阴影或痕迹，以提高触摸屏的外观质量和视觉效果\n' +
      '     ※接地与屏蔽(Ground & Shielding)：\n' +
      '          ★Ground(接地)作用:\n' +
      '             为电路提供一个基准电位，确保各个部分的电压稳定，减少电气噪声\n' +
      '             和干扰。在电容式触摸屏工作时，能让电流有一个稳定的回路，\n' +
      '             如当手指触碰屏幕时，体内的静电流入接地面，而产生微弱申流\n' +
      '             通过触控面板，接地为这个电流提供了通路\n' +
      '          ★Shielding(屏蔽)作用：\n' +
      '             通过材料/结构阻挡、吸收或反射干扰(电磁、辐射、声波等)，\n' +
      '             或防止内部信号外泄，保护设备、人员或环境，如电磁屏蔽防干扰、\n' +
      '             辐射屏蔽护安全、声学屏蔽降噪音等\n' +
      '     ※尺寸：OD、AA、VA、Thickness\n' +
      '          ★外形尺寸(OD: Outside Dimension)\n' +
      '             产品的外部尺寸，即整个触摸屏或显示面板包括边框等所有部分\n' +
      '             在内的最大尺寸。如手机屏幕，OD尺寸就从屏幕最左边到最右边、\n' +
      '             最上边到最下边的最大距离，包括了屏幕周边的边框部分\n' +
      '          ★动作区(AA: Active Area)\n' +
      '             有效区域，是指屏幕上真正用于显示图像或进行触控操作的区域，\n' +
      '             不包括边框、非显示区域等\n' +
      '          ★可视区(VA: Viewing Area)\n' +
      '             可视区域，是指用户在正常观看角度下能够清晰看到屏幕内容的区域\n' +
      '          ★厚度(Thickness)\n' +
      '             电容式触摸屏中ITO玻璃厚度有多种规格，\n' +
      '             常见的有0.4mm、0.55、0.7、1.1、1.8mm等，厚度公差一般为+0.05mm\n' +
      ' \n' +
      '２.薄膜功能片設計(Film Sensor Design)\n' +
      '     ※Film/Film功能片介绍(FilmFilm Sensor Introduce)：\n' +
      '         Film/Film Sensor，即基于柔性薄膜的电容式触摸功能片，从结构、原理、\n' +
      '         特点及应用展开介绍\n' +
      '     ※Film/Film功能片结构(FilmFilm Sensor Structure)：\n' +
      '         FF功能片以柔性薄膜(如PET)为基底，通过多层复合结构实现触摸感应，\n' +
      '         核心组成如下\n' +
      '          ★柔性基底(PET薄膜)：\n' +
      '             材质轻薄柔韧，厚度通常为 50-200μm，可弯曲折叠，适应曲面屏幕或\n' +
      '             异形设备设计，透光率高(≥90%)，确保屏幕显示效果不受影响\n' +
      '          ★透明导电层(ITO或替代材料)：\n' +
      '             在上下两层 PET 薄膜上分别镀覆ITO(氧化铟锡)或其他导电材料\n' +
      '             (如银纳米线、石墨烯)，形成X/Y轴电极层、电极图案通过光刻工艺制成，\n' +
      '             常见形状为菱形、网格状或条纹状，间距和密度决定触摸分辨率\n' +
      '          ★绝缘层(Dielectric Layer)：\n' +
      '             位于上下导电层之间，通常为超薄 PET 或光刻胶材质，厚度约 1-5μm，\n' +
      '             防止上下电极短路，同时形成电容耦合空间\n' +
      '          ★保护层(Hard Coat/OC层)：\n' +
      '             上层 PET 外侧覆盖硬化涂层(Hard Coat)，硬度可达 3H-4H，抗刮擦、\n' +
      '             防指纹；部分产品添加防眩光(AG)或防油渍(AF)涂层，提升使用体验\n' +
      '          ★软性电路板(FPC)：\n' +
      '             连接电极层与主控芯片，通常焊接在功能片边缘，传输触摸信号\n' +
      '     ※Film/Film功能片工作原理(FilmFilm Sensor Theory)：\n' +
      '         FF Sensor 基于电容式触摸原理，具体流程如下：\n' +
      '          ★电容耦合形成\n' +
      '             上下导电层分别作为发射(Tx)和接收(Rx)极，通过绝缘层形成平行板电容\n' +
      '             当手指(导电体)靠近或触摸屏时，手指与导电层之间形成附加电容，\n' +
      '             导致原电容值发生变化\n' +
      '          ★信号检测与定位\n' +
      '             控制器向Tx电极发送交变电压，Rx电极接收电流信号，\n' +
      '             触摸时电容变化会引起电流波动，控制器通过扫描X-Y电极矩阵，\n' +
      '             算出电容变化的坐标位置，实现触摸定位\n' +
      '          ★多点触控支持\n' +
      '             由于上下电极层独立，FF功能片可同时检测多个触摸点的电容变化，\n' +
      '             支持多点触控(如双指缩放、三指滑动等)\n' +
      '     ※Film/Film功能片厚度(FilmFilm SensorThickness)：\n' +
      '          ★消费类：\n' +
      '             Typical 2~10”，膜厚度FF0.25、FF0.43、FF0.5mmt，适配手机、\n' +
      '             平板等小型消费电子，轻薄灵敏，贴合便携需求\n' +
      '          ★人机介面类：\n' +
      '             Typical 7~12”，膜厚度FF0.25、FF0.43、FF0.5mmt，覆盖智能交互终端、\n' +
      '             车载中控等，平衡触感与耐用性\n' +
      '          ★工业控制类：\n' +
      '             Typical 14~18”，膜厚度FF0.25、FF0.43、FF0.5mmt，适配工业触摸屏、\n' +
      '             自助终端，满足复杂工况下的抗冲击、高稳定需求\n' +
      '          ★医疗类：\n' +
      '             Typical 4~20”，膜厚度FF0.25、FF0.43、FF0.5mmt，\n' +
      '             覆盖医疗设备触摸屏(如监护仪、诊断终端)，兼顾卫生易清洁与精准触控\n' +
      '          ★超大尺寸：\n' +
      '             Typical 27~65”， 膜厚度FF0.25、FF0.425、FF0.5mmt，覆盖商显大屏、\n' +
      '             数字标牌等，实现大尺寸场景下的稳定多点触控\n' +
      ' ',
    describe: 'ServDesignSensor',
    link: '',
    time: '2025/8/11',
  }
]

export const ServDesignFpcImg = [
  {
    id: 1,
    image: require('../images/ServiceImg/DesignFpc/FpcThicknessDesignA.png'),
    alt: 'images/ServiceImg/DesignFpc/FpcThicknessDesignA.png',
  },
  {
    id: 2,
    image: require('../images/ServiceImg/DesignFpc/FpcThicknessDesignB.png'),
    alt: 'images/ServiceImg/DesignFpc/FpcThicknessDesignB.png',
  },
  {
    id: 3,
    image: require('../images/ServiceImg/DesignFpc/FpcThicknessDesignC.png'),
    alt: 'images/ServiceImg/DesignFpc/FpcThicknessDesignC.png',
  },
  {
    id: 4,
    image: require('../images/ServiceImg/DesignFpc/FpcThicknessDesignF.png'),
    alt: 'images/ServiceImg/DesignFpc/FpcThicknessDesignF.png',
  },
  {
    id: 5,
    image: require('../images/ServiceImg/DesignFpc/FpcThicknessDesignG.png'),
    alt: 'images/ServiceImg/DesignFpc/FpcThicknessDesignG.png',
  },
  {
    id: 6,
    image: require('../images/ServiceImg/DesignFpc/FunctionTestPc.png'),
    alt: 'images/ServiceImg/DesignFpc/FunctionTestPc.png',
  },
  {
    id: 7,
    image: require('../images/ServiceImg/DesignFpc/HowPCapTouchWorksB.png'),
    alt: 'images/ServiceImg/DesignFpc/HowPCapTouchWorksB.png',
  },
  {
    id: 8,
    image: require('../images/ServiceImg/DesignFpc/HowPCapTouchWorksC.png'),
    alt: 'images/ServiceImg/DesignFpc/HowPCapTouchWorksC.png',
  },
  {
    id: 9,
    image: require('../images/ServiceImg/DesignFpc/PCapStructure.png'),
    alt: 'images/ServiceImg/DesignFpc/PCapStructure.png',
  },
  {
    id: 10,
    image: require('../images/ServiceImg/DesignFpc/SensorOcaAttachA.png'),
    alt: 'images/ServiceImg/DesignFpc/SensorOcaAttachA.png',
  },
  {
    id: 11,
    image: require('../images/ServiceImg/DesignFpc/SensorThicknessDesign.png'),
    alt: 'images/ServiceImg/DesignFpc/SensorThicknessDesign.png',
  },
  // {
  //   id: 11,
  //   image: require('../images/ServiceImg/Design/ServDesign-11.jpg'),
  //   alt: 'images/ServiceImg/Design/ServDesignFpc-11.jpg',
  // },
  // {
  //   id: 12,
  //   image: require('../images/ServiceImg/Design/ServDesign-12.jpg'),
  //   alt: 'images/ServiceImg/Design/ServDesignFpc-12.jpg',
  // },
]

export const ServDesignFpcTxt = [
  // {
  //   id: 0,
  //   alt: 'images/ServiceImg/Design/ServDesignTouch.jpg',
  //   name: 'Services / FPC Design',
  //   title: 'Services / FPC Design',
  //   subtitle: 'FPC',
  //   text:
  //     '',
  //   describe: 'ServDesignFPC',
  //   link: '',
  //   time: '2025/8/10',
  // },
  {
    id: 1,
    // image: require(''),
    alt: 'images/ServiceImg/Design/ServDesignFPC.jpg',
    name: '４.FPC Design(FPC设计)',
    title: 'FPC/FPCA设计',
    subtitle: 'FPC设计:',
    text:
      '\n   ' +
      '１.外型设计Outside Dimension(OD)：\n' +
      '        ※OD(外形)，即 FPC 成品（含封装/补强等）的最大外轮廓直径，\n' +
      '            用于明确其空间占用及装配适配性。\n' +
      '\n   ' +
      '２.厚度要求：\n' +
      '        FPC(软性线路板)设计中的厚度要求受多种因素影响，以下是一些主要方面\n' +
      '        ※FPC常用的基材有聚酰亚胺(PI)和聚酯(PET)等\n' +
      '            ★ PI厚度：12.5-75μm，耐高温、机械性高时选较薄款\n' +
      '            ★ PET厚度：25-100μm，成本敏感、性能要求不高时选稍厚款\n' +
      '        ※铜箔厚度：\n' +
      '            ★ 常见的铜箔厚度有18μm、35μm和70μm等\n' +
      '        ※覆盖层厚度：\n' +
      '            ★ 覆盖膜的厚度一般在25μm到50μm左右，阻焊油墨的厚度相对较薄，\n' +
      '                Typical: 10μm到20μm\n' +
      '        ※总体厚度要求：\n' +
      '            ★ FPC的总体厚度是上述各部分厚度之和，还需考虑生产工艺中的\n' +
      '                公差等因素。不同应用场景对FPC总体厚度要求差异较大\n' +
      '        ※FPC设计中的厚度要求：\n' +
      '            ★ 需要综合考虑应用场景、性能需求、成本等多方面因素，\n' +
      '                以达到最佳的设计效果\n' +
      '\n   ' +
      '３.基材：\n' +
      '        ※聚酰亚胺(PI)：\n' +
      '            ★ 具有优异的耐高温、机械性能和电气绝缘性能，能在-269℃至400℃的\n' +
      '                温度范围内保持稳定性能，适用于对可靠性和稳定性要求高的场合\n' +
      '        ※聚酯(PET)：\n' +
      '            ★ 成本较低，具有良好的柔韧性和一定的电气性能\n' +
      '        ※铜箔：\n' +
      '            ★ 电解铜箔：\n' +
      '                通过电解工艺制成，表面粗糙度较高，与基材的结合力较好，\n' +
      '                导电性能优良，适用于对电气性能要求高的FPC\n' +
      '            ★ 压延铜箔：\n' +
      '                经压延工艺生产，具有较好的柔韧性和较低的表面粗糙度，\n' +
      '                在一些对弯折性能要求极高的FPC中应用广泛\n' +
      '        ※覆盖层材料：\n' +
      '            ★ 覆盖膜由PI或PET等材料制成，用于保护FPC的线路，\n' +
      '                增强其机械和绝缘性能，同时具有良好的柔韧性，\n' +
      '                能适应FPC的弯折和扭曲\n' +
      '        ※阻焊油墨：\n' +
      '            ★ 主要作用是防止焊接时焊料误沾到不需要焊接的部位，\n' +
      '                同时提供一定的绝缘保护和防腐蚀功能， \n' +
      '                具有良好的印刷性能和固化性能\n' +
      '        ※粘结剂：\n' +
      '            ★ 丙烯酸类粘结剂、环氧树脂类粘结剂\n' +
      '\n   ' +
      '４.布线(Routing)：\n' +
      '        ※按照Design Guide布线建议\n' +
      '        ※依照电源稳定性规定\n' +
      '        ※建议加大铜面积以提高灵敏度\n' +
      '        ※使用hush-ground接地来找到一个最佳点，既能提高免疫力，\n' +
      '            又能避免引入过多的寄生电容，从而降低灵敏度\n' +
      '        ※使用主动驱动防护罩\n' +
      '        ※允许覆盖材料的厚度和类型限制\n' +
      '\n   ' +
      '５.FPC热压ACF选择：\n' +
      '        ※15吋及以下用Sony CP9731SB\n' +
      '        ※15吋以上用Hitachi AC-7106U-25\n' +
      '\n   ' +
      '６.连接器(Connector)：\n' +
      '        在软性电路板的布线(Routing)中，链接头(Connector)起着关键作用，\n' +
      '        以下是相关要点\n' +
      '        ※连接头类型与特点\n' +
      '            ★板对板连接器：用于电路软板与软板或软板与硬板连接，\n' +
      '               具有较高的连接密度和稳定性，能实现多个信号的同时传输\n' +
      '            ★线对板连接器：主要用于将柔性线缆连接到软性电路板上，方便灵活，\n' +
      '               可根据需要选择不同的引脚数量和间距\n' +
      '            ★FFC/FPC连接器：专门为扁平柔性电缆(FFC)或软性线路板(FPC)设计，\n' +
      '               具有轻薄、紧凑的特点，适用于空间有限的电子设备\n' +
      '        ※布局考虑\n' +
      '            ★应根据电路板的整体结构和信号流向来确定链接头的位置，\n' +
      '               尽量将其放置在电路板的边缘或角落，便于与外部设备连接，\n' +
      '               同时避免占用过多的有效空间\n' +
      '            ★对于有多个链接头的软性电路板，要合理安排它们的布局，\n' +
      '               使布线更加顺畅，减少交叉和迂回，以提高电路板的性能和可靠性\n' +
      '        ※布线规则\n' +
      '            ★从链接头引出的信号线应尽量保持短而直，减少信号传输的延迟和损耗。\n' +
      '               对于高速信号，可采用差分信号线对，并进行适当的屏蔽和\n' +
      '               阻抗匹配处理\n' +
      '            ★电源线和地线应尽量靠近链接头，以提供稳定的电源供应和良好的接地。\n' +
      '               同时要注意电源线和信号线之间的间距，防止电源噪声对信号产生干扰\n' +
      '            ★布线时要避免在链接头附近有过孔或障碍物，以免影响焊接和信号传输。\n' +
      '               如无法避免，应尽量将过孔放置在远离链接头引脚的位置\n' +
      '        ※焊接与装配\n' +
      '            ★链接头的焊接质量直接影响到软性电路板的性能和可靠性。\n' +
      '               在焊接过程中，要严格控制焊接温度、时间和焊接材料的用量，\n' +
      '               确保引脚与电路板之间形成良好的电气连接和机械连接\n' +
      '            ★在装配过程中，要注意链接头的安装方向和位置，\n' +
      '               确保其与其他部件的配合准确无误。\n' +
      '               同时要避免对链接头施加过大的外力，以免造成引脚变形或损坏\n' +
      '\n   ' +
      '７.FPC/FPCA/Sensor Bonding：\n' +
      '       将软性电路板(FPC/FPCA)与功能片(Sensor)进行电气和机械连接的关键工艺。\n' +
      '       以下是相关介绍\n' +
      '       ※常见技术\n' +
      '           ★热压焊接：\n' +
      '              通过加热的焊头将FPC上的焊盘与Sensor或其他连接部件上的焊盘\n' +
      '              通过焊锡连接。这种方法适合高精度、小尺寸焊点，\n' +
      '              常用于连接显示屏排线等\n' +
      '           ★ACF热压连接：\n' +
      '              使用含导金球的异方性导电胶膜(ACF)，通过热压使金球在垂直方向导通，\n' +
      '              实现FPC与Sensor之间的电气连接，同时在水平方向保持绝缘。\n' +
      '              该技术无铅环保，适合微间距焊盘\n' +
      '           ★激光焊接：\n' +
      '              利用激光局部加热，熔化焊料实现FPC与Sensor或其他部件的连接。\n' +
      '              它可以实现高精度的焊接，对周围部件的热影响较小\n' +
      '           ★导电胶粘接：\n' +
      '              通过银浆等导电胶粘接FPC与Sensor基板，固化后形成导电通路。\n' +
      '              这种方法操作相对简单，适用于一些对焊接精度要求不是特别高的场合\n' +
      '       ※工艺流程\n' +
      '           ★包括贴附、对位、热压/冷却等步骤。\n' +
      '              准备阶段要确保FPC、Sensor表面清洁，无杂质、油污等。\n' +
      '              对位环节将FPC与Sensor的连接部位精确对准，借助视觉对位系统实现。\n' +
      '              连接过程根据所选技术，如热压焊接需控制好温度、\n' +
      '              压力和时间，使ACF发挥作用。最后通过固化/冷却使连接稳定，\n' +
      '              形成可靠的电气和机械连接\n' +
      '           ★FPC/FPCA Bonding需满足较高的精度要求，确保连接的可靠性和稳定性，\n' +
      '              以保证信号传输的质量和效率。同时，要考虑材料兼容性，\n' +
      '           ★如焊料、胶粘剂需与FPC的铜层、覆盖膜以及Sensor的材料相匹配，\n' +
      '              避免出现腐蚀、脱落等问题\n' +
      '' +
      '\n   ' +
      '８.功能测试：\n' +
      '       布线(Routing)中的功能测试是确保FPC/PCB设计正确性和可靠性的重要环节，\n' +
      '       主要包括以下几个方面：\n' +
      '       ※连通性测试\n' +
      '           ★测试目的：\n' +
      '              检查布线后各元器件引脚之间是否按照设计要求正确连接，有无断路、\n' +
      '              短路等问题\n' +
      '           ★测试方法：\n' +
      '              通常使用自动测试设备(ATE)或飞针测试系统，\n' +
      '              通过向PCB上的测试点施加电信号，测量线路的导通情况，\n' +
      '              判断是否存在连接错误，\n' +
      '       ※信号完整性测试\n' +
      '           ★测试目的：\n' +
      '              确保高速信号在传输过程中保持良好的质量，避免出现信号失真、反射、\n' +
      '              串扰等问题，以保证系统的稳定运行\n' +
      '           ★测试方法：\n' +
      '              使用示波器和逻辑分析仪等仪器，对关键信号进行实时监测和分析。\n' +
      '              例如，观察信号的上升沿、下降沿、幅值、过冲、\n' +
      '              振铃等参数是否符合设计要求，通过眼图分析来评估信号的整体质量\n' +
      '       ※电源完整性测试\n' +
      '           ★测试目的：\n' +
      '              验证电源分配网络(PDN)的设计是否合理，能否为各个元器件提供稳定、\n' +
      '              干净的电源，避免出现电源噪声、电压波动等问题\n' +
      '           ★测试方法：\n' +
      '              使用示波器测量线上的纹波电压，通过仿真工具分析表面的阻抗分布，\n' +
      '              检查去耦合电容的布局和参数是否合理，确保电源系统能够满足\n' +
      '              不同负载条件下的供电需求\n' +
      '       ※电磁兼容性(EMC)测试\n' +
      '           ★测试目的：\n' +
      '              评估布线设计对电磁干扰(EMI)的抑制能力以及\n' +
      '              PCB对外界电磁干扰的抗扰度(EMS)，确保PCB在电磁环境下能正常工作，\n' +
      '              同时不会对周围设备产生有害的电磁干扰\n' +
      '           ★测试方法：\n' +
      '              通过电磁屏蔽室中的EMI/EMS测试设备，测量PCB/FPC在不同频率下的电\n' +
      '              磁辐射强度和抗干扰能力。\n' +
      '              如采用近场探头检测PCB/FPC上的电磁泄漏源，通过注入干扰信号来测试\n' +
      '              PCB/FPC的抗扰性能，根据测试结果优化布线设计，如调整信号线的布局、\n' +
      '              增加屏蔽措施等\n' +
      '\n' +
      ' ',
    describe: 'ServDesignFpc',
    link: '',
    time: '2025/8/14',
  },
]

export const ServDesignLamImg = [
  {
    id: 1,
    image: require('../images/ServiceImg/DesignLam/BondingTestPcb.png'),
    alt: 'images/ServiceImg/DesignLam/BondingTestPcb.png',
  },
  {
    id: 2,
    image: require('../images/ServiceImg/DesignLam/CtpStructure.png'),
    alt: 'images/ServiceImg/DesignLam/CtpStructure.png',
  },
  {
    id: 3,
    image: require('../images/ServiceImg/DesignLam/FunctionTestPc.png'),
    alt: 'images/ServiceImg/DesignLam/FunctionTestPc.png',
  },
  {
    id: 4,
    image: require('../images/ServiceImg/DesignLam/HowPCapTouchWorksC.png'),
    alt: 'images/ServiceImg/DesignLam/HowPCapTouchWorksC.png',
  },
  {
    id: 5,
    image: require('../images/ServiceImg/DesignLam/LaminationStructure.png'),
    alt: 'images/ServiceImg/DesignLam/LaminationStructure.png',
  },
  {
    id: 6,
    image: require('../images/ServiceImg/DesignLam/PCapStructure.png'),
    alt: 'images/ServiceImg/DesignLam/PCapStructure.png',
  },
  // {
  //   id: 7,
  //   image: require('../images/ServiceImg/DesignLam/ServDesign-7.jpg'),
  //   alt: 'images/ServiceImg/DesignLam/ServDesignLam-7.jpg',
  // },
  // {
  //   id: 8,
  //   image: require('../images/ServiceImg/DesignLam/ServDesign-8.jpg'),
  //   alt: 'images/ServiceImg/DesignLam/ServDesignLam-8.jpg',
  // },
  // {
  //   id: 9,
  //   image: require('../images/ServiceImg/DesignLam/ServDesign-9.jpg'),
  //   alt: 'images/ServiceImg/DesignLam/ServDesignLam-9.jpg',
  // },
  // {
  //   id: 10,
  //   image: require('../images/ServiceImg/DesignLam/ServDesign-10.jpg'),
  //   alt: 'images/ServiceImg/DesignLam/ServDesignLam-10.jpg',
  // },
]

export const ServDesignLamTxt = [
  // {
  //   id: 0,
  //   // image: require(''),
  //   alt: 'images/ServiceImg/Design/ServDesignTouch.jpg',
  //   name: 'Services / Cover+Sensor Laminate Design',
  //   title: 'Services / 盖板+功能片+Fpc贴合设计(Cover+Sensor Laminate)',
  //   subtitle: 'Laminate',
  //   // text:
  //   //   ' ',
  //   describe: 'ServiceDesignLaminate',
  //   link: '',
  //   time: '2025/9/5',
  // },
  {
    id: 1,
    // image: require(''),
    alt: 'images/ServiceImg/Design/ServDesignLaminate.jpg',
    name: '５.Laminate Design(设计Glass Cover / Plastic Cover)',
    title: 'Cover+Sensor贴合 & FPC热压 & 测试设计',
    subtitle: 'Cover+Sensor 贴合',
    text:
      '１.功能片贴附OCA设计(Sensor OCA Attach Design)：\n' +
      '     将盖板(Cover)、功能片(Sensor)和软性线路板(FPC)的组件进行贴合过程中，\n' +
      '     功能片与盖板之间通过光学透明胶(OCA)进行粘贴的工艺环节。\n' +
      '     以下是关于这一工艺的一些要点：\n' +
      '     ※工艺目的\n' +
      '         ★ 确保功能片与盖板之间有良好的光学耦合，使光线能够高效地透过，\n' +
      '             同时保证功能片能够准确地感知外部环境信息，如光线、压力等\n' +
      '         ★ 提供可靠的机械连接，使功能片在受到外力冲击或振动时，\n' +
      '             仍能保持与盖板的紧密结合，防止出现位移或脱落，\n' +
      '             从而保证整个组件的稳定性和可靠性\n' +
      '     ※工艺要求\n' +
      '         ★ OCA选择：\n' +
      '             根据功能片和盖板的材质、性能以及使用环境等因素，选择合适的OCA。\n' +
      '             例如，对于高分辨率的光学功能片，要求OCA具有高透光率、\n' +
      '             低雾度和良好的光学均匀性，以确保图像质量不受影响\n' +
      '         ★ 贴合精度：\n' +
      '             要保证功能片与盖板之间的贴合精度，误差通常控制在几十微米以内。\n' +
      '             这需要使用高精度的贴合设备和定位夹具，以确保功能片在盖板上的\n' +
      '             位置准确无误，避免因位置偏差而导致功能片性能下降或失效\n' +
      '         ★ 贴合压力和温度：\n' +
      '             贴合过程中需要精确控制压力和温度。适当的压力可以使OCA充分填充\n' +
      '             功能片与盖板之间的间隙，排除空气泡，提高贴合质量；而合适的温度\n' +
      '             则有助于OCA的流平和固化，提高其粘性和附着力。一般贴合压力，\n' +
      '             在几牛到几十牛之间，温度在室温到几十摄氏度之间具体数值\n' +
      '             根据OCA的特性和工艺要求而定\n' +
      '\n' +
      '２.FPC热压设计(Sensor Bonding FPC Design)：\n' +
      '    ※功能片与FPC借由ACF(异方性导电胶)，以高温热压连接并导通\n' +
      '\n' +
      '３.盖板+功能片+贴合设计(Cover+Sensor Laminate Design)：\n' +
      '    ※盖板和功能片通过SCA胶或OCA胶粘合在一起\n' +
      '\n' +
      '４.真空压合与脱泡设计(Autoclave)\n' +
      '    ※通过施加压力(常配合温度)消除材料贴合时产生的气泡，\n' +
      '        确保层间紧密结合的工艺步骤\n' +
      '\n' +
      '５.质量检测设计\n' +
      '    ※外观检测：\n' +
      '        ★ 主要检查贴合表面是否有气泡、杂质、划痕等缺陷，以及功能片与盖板的\n' +
      '            贴合边缘是否整齐、有无溢胶现象，这些外观缺陷可能会影响产品的\n' +
      '            美观和光学性能，需要及时发现并进行处理\n' +
      '    ※光学性能检测：\n' +
      '        ★ 通过专业的光学检测设备，如光谱仪、透过率测试仪等，\n' +
      '            检测功能片在贴合后的光学性能，如透光率、反射率、\n' +
      '            色彩均匀性等指标是否符合要求。如果光学性能不达标，\n' +
      '            可能需要调整工艺参数或更换OCA材料。\n' +
      '    ※机械性能检测：\n' +
      '        ★ 采用拉力测试、冲击测试等方法，评估功能片与盖板之间的结合强度。\n' +
      '            确保产品在正常使用和运输过程中，功能片不会因不当外力与盖板分离，\n' +
      '            保证产品的可靠性和稳定性\n' +
      '    ※可靠性测试：\n' +
      '        ★ 通过加速老化试验、耐久性试验等方法，评估组件在长期使用过程中的\n' +
      '            可靠性和寿命。\n' +
      '            例如，对组件进行高温、高湿、高低温循环等加速老化试验，\n' +
      '            模拟在恶劣环境下的使用情况，检测其性能是否会出现下降或失效的情况。\n' +
      '            通过长时间的连续运行测试，评估其耐久性和稳定性，\n' +
      '            确保产品在规定的使用寿命内能够稳定可靠地工作\n' +
      '    ※外观检测：\n' +
      '         ★ xxxxxx 图形与颜色：边缘遮盖必须盖住Sensor银线，\n' +
      '            且大于LCM AA 单边0.2mm\n' +
      '\n' +
      '６.Tunning & Testing\n' +
      '    调谐与测试环节，这是确保贴合后的组件性能达到预期要求的重要步骤。\n' +
      '    以下是具体介绍\n' +
      '    ※固件调试(Firmware Tunning)\n' +
      '        ★ 目的：\n' +
      '            对贴合后的组件进行微调，使其性能达到最佳状态。由于在贴合过程中，\n' +
      '            可能会对Sensor、 FPC等部件产生一定的影响，导致其性能出现微小偏差，\n' +
      '            需要通过调谐来修正\n' +
      '        ★ 内容：\n' +
      '            根据Sensor的类型和功能，可能涉及到对其灵敏度、响应时间、\n' +
      '            线性度等参数的调整\n' +
      '    ※功能测试(Testing)\n' +
      '        ★ 性能测试：\n' +
      '            检测FPC与Sensor之间的电气连接是否良好，信号传输是否稳定，\n' +
      '            有无短、断路等情形\n' +
      '        ★ 功能测试：\n' +
      '            验证组件在实际应用中的功能是否正常。例如将贴合后的组件\n' +
      '            集成到整个系统中，测试其是否能够与其他部件协同工作，\n' +
      '            准确地完成数据采集、传输和处理等功能\n' +
      '    ※在调谐与测试注意事项\n' +
      '        一旦发现问题，需要及时分析原因并采取相应的措施进行改进，\n' +
      '        以确保最终产品的质量和性能符合要求\n' +
      '',
    describe: 'ServDesignLaminate',
    link: '',
    time: '2025/9/5',
  }
]

// ServicesDesignData.js
// export const ServDesignTopImg = [
//   {
//     id: 1,
//     image: require('../images/ServiceImg/Design/CtpStructure.png'),
//     alt: 'images/ServiceImg/Design/CtpStructure.png',
//   },
//   {
//     id: 2,
//     image: require('../images/ServiceImg/Design/CoverGlassDesignB.png'),
//     alt: 'images/ServiceImg/Design/CoverGlassDesignB.png',
//   },
//   {
//     id: 3,
//     image: require('../images/ServiceImg/Design/DITOGlassSensor.png'),
//     alt: 'images/ServiceImg/Design/DITOGlassSensor.png',
//   },
//   {
//     id: 4,
//     image: require('../images/ServiceImg/Design/FilmSensorOverview.png'),
//     alt: 'images/ServiceImg/Design/FilmSensorOverview.png',
//   },
//   {
//     id: 5,
//     image: require('../images/ServiceImg/Design/FlimSensorIntroduction.png'),
//     alt: 'images/ServiceImg/Design/FlimSensorIntroduction.png',
//   },
//   {
//     id: 6,
//     image: require('../images/ServiceImg/Design/FpcThicknessDesignC.png'),
//     alt: 'images/ServiceImg/Design/FpcThicknessDesignC.png',
//   },
//   {
//     id: 7,
//     image: require('../images/ServiceImg/Design/FunctionTestPc.png'),
//     alt: 'images/ServiceImg/Design/FunctionTestPc.png',
//   },
//   {
//     id: 8,
//     image: require('../images/ServiceImg/Design/HowPCapTouchWorksA.png'),
//     alt: 'images/ServiceImg/Design/HowPCapTouchWorksA.png',
//     // link: 'https://xxxxxx.com/design/xxxxxx',
//   },
// ]

// export const ServDesignSensor = [
//   {
//     id: 1,
//     // image: require(''),
//     alt: 'images/ServiceImg/Design/ServDesignSensor.jpg',
//     name: 'Sensor Glass/Film Design',
//     title: 'Glass Sensor / Film Sensor 設計',
//     subtitle: 'Glass Sensor / Film Sensor 設計',
//     text:
//       '1．功能片設計\n' +
//       '   • FPC接点：电容式触摸屏中FPC(软性线路板)与其他部件连接的部位\n' +
//       '   • 消影：通过特定的技术和工艺处理，减少或消除触摸屏上因氧化铟锡(ITO)线路引起的视觉上的阴影或痕迹，\n' +
//       '                  以提高触摸屏的外观质量和视觉效果\n' +
//       // '   • 導通線路：銀導通線路、金屬導通線路\n' +
//       '   • 絕緣層線路保護：導線線路容易刮傷，考慮膜厚影響蓋板貼合\n' +
//       '   • Ground & Shielding：\n' +
//       '     Ground(接地)为电路提供一个基准电位，确保各个部分的电压稳定，减少电气噪声和干扰。在电容式触摸屏工作时，能让电流有一个稳定的回路，比如当手指触碰屏幕时，体内的静电流入地面而产生微弱申流通过触控面板，接地为这个电流提供了通路\n' +
//       '   • 尺寸：OD、AA、VA\n' +
//       '   • 厚度：\n' +
//       '\n' +

//       '2．Sensor Glass特點：\n' +
//       '   • 化學強化\n' +
//       '   • 堅固耐用\n' +
//       '\n' +
//       '2．Film Glass特點：\n' +
//       '   • 輕薄\n' +
//       '\n' +
//       '',
//     nameEng: 'Aerospace Touch Screen Display Solutions',
//     titleEng: 'Aerospace Touch Screen Display Solutions',
//     subtitleEng: 'Touchscreen Solutions for High-Reliability Applications',
//     textEng:
//       '１.Sensor Design\n' +
//       'If your industrial LCD display faces rough environmental conditions, your LCD design must prioritize coverglass protection and ruggedization.\n' +
//       '\n' +
//       '２.Sensor Glass Features:\n' +
//       '     • Chemically-Strengthened\n' +
//       '     • Ruggedized\n' +
//       '\n' +
//       '',
//     describe: 'ServDesignSensor',
//     link: '',
//     time: '2025/2/18',
//      '2．Sensor Glass特點：\n' +
//      '   • 化學強化\n' +
//      '   • 堅固耐用\n' +
//      '\n' +
//      '2．Film Glass特點：\n' +
//      '   • 輕薄\n' +
//      '\n' +
//      '',
//    nameEng: 'Aerospace Touch Screen Display Solutions',
//    titleEng: 'Aerospace Touch Screen Display Solutions',
//    subtitleEng: 'Touchscreen Solutions for High-Reliability Applications',
//    textEng:
//      '１.Sensor Design\n' +
//      'If your industrial LCD display faces rough environmental conditions, your LCD design must prioritize coverglass protection and ruggedization.\n' +
//      '\n' +
//      '２.Sensor Glass Features:\n' +
//      '     • Chemically-Strengthened\n' +
//      '     • Ruggedized\n' +
//      '\n' +
//      '',
//   },
// ]

// export const ServDesignCover = [
//   {
//     id: 1,
//     // image: require(''),
//     // image: require('../images/ServiceImg/Design/ServDesign'),
//     // alt: 'images/ServiceImg/Design/ServDesignIndustrial.jpg',
//     name: 'Cover Glass Introduction',
//     title: '什麼是觸控螢幕保護玻璃？',
//     text:
//       '1．玻璃保護蓋板介紹：\n' +
//       '   也稱為保護玻璃或保護玻璃，廣泛應用於智慧型手機和平板電腦等具有觸控功能的電子設備。\n' +
//       '   應用於前屏、後蓋，提供防摔、防刮、抗壓、耐高溫、液晶保護、美觀等必備功能.\n' +
//       '   觸控螢幕保護玻璃是您在手機和平板電腦等裝置上與之互動的頂層。它與檢測您的觸摸的層不同。\n' +
//       '   這種玻璃在保護設備免受損壞並確保清晰的可視性和靈敏的觸摸方面發揮著至關重要的作用。\n' +
//       '   先進的玻璃生產技術：\n' +
//       '   • 蓋板玻璃產業隨著先進的生產技術而不斷發展。主要有兩種方法：溢流法、浮動法。\n' +
//       '   • 在溢流法中，生產過程中原玻璃片表面不接觸其他介面，使最終產品無需研磨或拋光即可保持高強度，從而提高產品良率。\n' +
//       '   • 浮法技術較成熟，產能較高，成本較低。它可以生產大尺寸玻璃，並以其成本優勢而聞名，儘管與溢流法相比，它的生產穩定性較低。\n' +
//       '\n' +
//       '2．蓋玻蓋板類型：\n' +
//       '   • 康寧大猩猩玻璃(Gorilla\n' +
//       '   • 旭龍跡玻璃(Dragontrail) \n' +
//       '   • 藍寶石水晶玻璃\n' +
//       '   • 肖特鋁矽酸鹽玻璃\n' +
//       '   • 鈉鈣玻璃\n' +
//       '   • 硼矽酸鹽玻璃\n' +
//       '\n' +
//       '3．高品質蓋板玻璃的優勢\n' +
//       '   • 耐刮擦性高：硬度達到6~9H，避免粗糙物體劃傷\n' +
//       '   • 耐用性：玻璃隨著時間的推移而承受磨損的能力\n' +
//       '   • 明晰：高品質蓋板玻璃晶瑩剔透，螢幕上看起來都很清晰，意味著鮮豔的色彩和清晰的影像\n' +
//       '   • 表面處理：防眩光(AG)、抗反射(AR)、防指紋(AF)、抗菌\n' +
//       '   • 防爆玻璃：防爆玻璃設計可承受高衝擊而不破碎\n' +
//       '   • 厚度選擇：玻璃的厚度影響其強度和重量，較厚的玻璃通常可以提供更好的保護，\n' +
//       '   • 形狀訂製：弧形玻璃(曲面)、圓角邊緣、直角和不規則形狀\n' +
//       '   • 鑽孔：通孔、盲孔\n' +
//       '   • 表面絲網印刷： 此過程將設計或顏色直接應用到玻璃表面上\n' +
//       '\n' +
//       '3．蓋玻蓋板規格：\n' +
//       '   • 厚度設計：搭配整體機構考量\n' +
//       '   • 材質：鈉鈣、\n' +
//       '   • 圖形與顏色：邊緣遮蓋必須蓋住Sensor銀線，且大於LCM AA 單邊0.2mm\n' +
//       '   • 圖形與字符：\n' +
//       '   • 膜層厚度：印刷必須2~3次，以避免針孔，印刷總厚度小於15um\n' +
//       '   • 鍍膜： AR、AF、AS\n' +
//       '   • 防爆模：\n' +
//       '   • 翹曲度：\n' +
//       '   • 強化：化學強化、物理強化，防刮達到6~9H\n' +
//       '\n' +
//       '4．複合板蓋板\n' +
//       '   • 尺寸設計：OD、AA、VA 設計\n' +
//       '   • 1.0、2.0mm\n' +
//       '   • 材質：PMMA+PC 2層、PMMA+PC+PMMA 3層\n' +
//       '\n',
//     titleEng: 'Decolation Cover Design',
//     textEng:
//       '\n' +
//       '\n',
//     describe: 'ServDesignCover',
//     link: 'https://www.eagle-touch.com/zh-TW/all-you-need-to-know-about-touch-screen-cover-glass/',
//     time: '2025/2/18',
//   },
//   {
//     id: 2,
//     // image: require(''),
//     // image: require('../images/ServiceImg/Design/ServDesign'),
//     // alt: 'images/ServiceImg/Design/ServDesignIndustrial.jpg',
//     name: 'Cover Design',
//     title: '蓋板(Glass Cover / Plastic Cover)設計',
//     text:
//       '如果您的顯示器(LCM)面臨惡劣的環境條件，您的模組設計必須優先考慮蓋板玻璃的保護和加固。\n' +
//       '1．玻璃保護蓋板：\n' +
//       '   • 尺寸設計：OD、AA、VA 設計\n' +
//       '   • 厚度設計：搭配整體機構考量\n' +
//       '   • 材質：鈉鈣、\n' +
//       '   • 圖形與顏色：邊緣遮蓋必須蓋住Sensor銀線，且大於LCM AA 單邊0.2mm\n' +
//       '   • 圖形與字符：\n' +
//       '   • 膜層厚度：印刷必須2~3次，以避免針孔，印刷總厚度小於15um\n' +
//       '   • 鍍膜： AR、AF、AS\n' +
//       '   • 防爆模：\n' +
//       '   • 翹曲度：\n' +
//       '   • 強化：化學強化、物理強化，防刮達到6~9H\n' +
//       '\n' +
//       '2．複合板蓋板\n' +
//       '   • 尺寸設計：OD、AA、VA設計\n' +
//       '   • 厚度設計：取決於複合板材厚度，一般為1.0、2.0mm\n' +
//       '   • 材質：PMMA+PC 2層、PMMA+PC+PMMA 3層\n' +
//       '\n' +
//       '\n',
//     titleEng: 'Decolation Cover Design',
//     textEng:
//       '\n' +
//       '\n',
//     describe: 'ServDesignCover',
//     link: '',
//     time: '2025/2/18',
//   },
// ]

// export const ServDesignFpc = [
//   {
//     id: 1,
//     // image: require(''),
//     // image: require('../images/ServiceImg/Design/ServDesign'),
//     // alt: 'images/ServiceImg/Design/ServDesignIndustrial.jpg',
//     name: 'FPC/FPCA/PCBA Design',
//     title: 'FPC/FPCA/PCBA設計',
//     text:
//       '1．FPC設計\n' +
//       '   • 外型設計：OD\n' +
//       '   • 厚度要求：\n' +
//       '   • 材質：\n' +
//       '   • 佈線(Routing)：\n' +
//       '      ＊ 按照Design Guide佈線建議\n' +
//       '      ＊ 依照電源穩定性規定\n' +
//       '      ＊ 建議加大銅面積以提高靈敏度\n' +
//       '      ＊ 使用hush-ground接地來找到一個最佳點，既能提高免疫力，又能避免引入過多的寄生電容，從而降低靈敏度、\n' +
//       '      ＊ 使用主動驅動防護罩\n' +
//       '      ＊ 允許覆蓋材料的厚度和類型限制\n' +
//       '   • FPC熱壓：ACF選擇\n' +
//       '   • 連接頭：\n' +
//       '   • 功能測試：\n' +
//       '\n' +
//       '2．FPCA設計\n' +
//       '   • 外型設計：OD\n' +
//       '   • 厚度要求：\n' +
//       '   • 材質：\n' +
//       '   • 走線layout：雙面軟板走線\n' +
//       '   • FPC Bonding：ACF選擇\n' +
//       '   • Connector：\n' +
//       '   • Control IC：\n' +
//       '   • Firmware 調適：\n' +
//       '   • 功能測試：短路測試\n' +
//       '\n' +
//       '' +
//       '3．Control Board(PCBA)設計\n' +
//       '   • Outsourcing：\n' +
//       '   • Control IC：\n' +
//       '   • Firmware 調適：\n' +
//       '   • 功能測試：\n' +
//       '\n' +
//       '' +
//       '4．Control Board(PCBA)設計' +
//       '' +
//       '',
//     titleEng: '',
//     textEng:
//       '\n' +
//       '\n' +
//       '\n' +
//       '\n' +
//       '\n',
//     describe: 'ServDesignFpc',
//     link: '',
//     time: '2025/2/16',
//   },
// ]

// export const ServDesignIntegrate = [
//   {
//     id: 1,
//     // image: require(''),
//     // image: require('../images/ServiceImg/Design/ServDesign'),
//     // alt: 'images/ServiceImg/Design/ServDesignIndustrial.jpg',
//     name: 'Integration/Lamination',
//     title: 'Cover+(Sensor+Fpc) 貼合',
//     text:
//     '1．Sensor OCA Attach\n' +
//     '   • \n' +
//     '   • \n' +
//     '\n' +
//     '2．FPC/FPCA Bonding\n' +
//     '   • \n' +
//     '   • \n' +
//     '\n' +
//     '3．Laminatie\n' +
//     '   • \n' +
//     '   • \n' +
//     '\n' +
//     '4．Tunning & Testing\n' +
//     '   • \n' +
//     '   • \n' +
//     '\n',
//     titleEng: '',
//     textEng:
//       '　' +
//       '　' +
//       '　' +
//       '　' +
//       '　' +
//       '',
//     describe: 'ServDesignIntegrate',
//     link: '',
//     time: '2025/2/16',
//   },
// ]

// export const ServDesignTheory =
// [
//   {
//      id: 0,
//     image: require('../images/ServiceImg/GGPCapTouchStruture.png'),
//     alt: '../GGPCapTouchStruture.png',
//     name: 'How Does PCap Touch Work?',
//     title: 'P-Cap 觸控面板',
//     subtitle: '結構圖：',
//     text:
//       '結構圖：\n' +
//       '   投射電容式觸控螢幕由多層組成。關鍵組件包括：\n' +
//       '   • 蓋板：絕緣玻璃蓋板或塑膠蓋板，您觸摸的螢幕表面。\n' +
//       '   • 光學膠：\n' +
//       '   • 功能片：電極層(X,Y Grid)，於蓋板下方\n' +
//       '      ＊ 上層電極層\n' +
//       '      ＊ 玻璃基板\n' +
//       '      ＊ 下層電極層\n' +
//       '      ＊ 軟性線路板\n' +
//       '   • 控制IC：監控和處理觸控事件的系統。\n' +
//       '\n' +
//       '\n',
//     nameEng: '',
//     titleEng: 'How Does PCap Touch Work?',
//     subtitleEng: 'The Structure:',
//     textEng:
//       '１.The Structure:\n' +
//       'A projected capacitive touchscreen is made of multiple layers. The key components are:\n' +
//       '  • Insulating Glass or Plastic Cover: The surface of the screen that you touch.\n' +
//       '  • Electrode Layer (X and Y Grids): Underneath the surface, there are two layers of conductive material arranged in a grid. One grid consists of rows, and the other of columns, forming a matrix of intersecting electrodes.\n' +
//       '  • Controller: The system that monitors and processes touch events.\n' +
//       'The conductive material (usually made from a transparent material like Indium Tin Oxide, or ITO) forms a capacitor at each intersection of the grid, creating a matrix of capacitive sensors.\n' +
//       '\n',
//     describe: 'ServDesignTheory',
//     // link: '',
//     time: '2025/2/13',
//   },
//   {
//     id: 1,
//     // image: require('../images/ServiceImg/GGPCapTouchStruture.png'),
//     // alt: '../GGPCapTouchStruture.png',
//     name: 'How Does PCap Touch Work?',
//     title: 'PCap 觸控面板如何運作？',
//     subtitle: '結構：',
//     text:
//     '1．結構：\n' +
//     '   投射電容式觸控螢幕由多層組成。關鍵組件包括：\n' +
//     '   • 蓋板：絕緣玻璃蓋板或塑膠蓋板，您觸摸的螢幕表面。\n' +
//     '   • 功能片：電極層(X,Y Grid)，於蓋板下方，附於載體的兩層排列成網格的導電材。分別由行與列(X/Y)組成，形成相交電極矩陣，\n' +
//     '                      導電材料(通常由氧化銦錫或 ITO 等透明材料製成)在網格的每個交叉點形成一個電容器，從而創建電容式感測器矩陣。\n' +
//     '   • 控制IC：監控和處理觸控事件的系統。\n' +
//     '\n' +
//       '2．電容式感應：\n' +
//       '   電極會不斷產生微小的靜電場。當手指（或任何導電物體）靠近或觸摸表面時，會引起局部靜電場的變化，因為人體可以導電並改變電容。\n' +
//       '   • 電容是電氣系統在電場中儲存能量的特性。螢幕透過檢測電容的變化來運作。\n' +
//       '   每次觸摸都會引起接觸點處電容的可測量變化。控制器會偵測到這種變化，並透過比較來自電網的訊號來精確定位觸控的位置。\n' +
//       '\n' +
//       '3．投射電容方式：\n' +
//       '   在 P-Cap 系統中，來自電極的電場「投射」到表面之外，即使沒有直接接觸（例如透過手套或薄表面）也可以檢測到觸摸。\n' +
//       '   叉點都充當獨立的感測器，因此系統可以偵測多個觸控點。\n' +
//       '\n' +
//       '4．多點觸控：\n' +
//       '   P-Cap 能夠進行多點觸控偵測，因為它可以同時追蹤多個點的電容變化。\n' +
//       '   這是透過感應整個電極網格的變化並根據訊號強度和模式區分不同的觸摸來實現的。\n' +
//       '\n' +
//       '5．投射電容式觸控的優點：\n' +
//       '   • 高耐用性：即使表面有刮痕或髒污仍能運作\n' +
//       '   • 多點觸控支援：允許捏合縮放、旋轉等手勢\n' +
//       '   • 反應速度快：提供快速、精確的觸控反應\n' +
//       '   • 無需校準：在各種環境下都能保持長期穩定\n' +
//       '\n' +
//       '6．觸控電容模型\n' +
//       '   與自電容測量不同，對於給定的相互感測器佈局，沒有簡單的方法來近似預期的觸控電容。\n' +
//       '   平行板近似不適用，因為在這種情況下「板」是 X 和 Y 電極的片段，比觸控蓋小得多。\n' +
//       '   使用者的觸摸接觸主要由電極對和指尖之間的邊緣場和點場決定\n' +
//       '\n' +
//       ' 在設計互電容感測器時，可以優化節點佈局以滿足應用要求，例如：\n' +
//       '   • 最大靈敏度\n' +
//       '   • 最佳噪音容忍度\n' +
//       '   • 最佳防水效果\n' +
//       '   • 最小預設感測器電容(某些擷取技術對感測器電容有限制)\n' +
//       '   • 最低功耗\n' +
//       '   • 最小觸控延遲\n' +
//       '\n' +
//       '   所有應用程式都需要在這些屬性之間進行權衡，因為實現一個屬性就意味著要損害其他屬性。\n' +
//       '   舉例來說，使用高交錯電極可達到最強的靈敏度。\n' +
//       '   然而，要實現最小感測器電容，需要 X 和 Y 之間有更大的間距。\n' +
//       '   增加 X-Y 分離會減少預設的 X-Y 電容，但也會減少電極之間平行段的長度。\n' +
//       '\n' +
//       '\n',
//     nameEng: '',
//     titleEng: 'How Does PCap Touch Work?',
//     subtitleEng: 'The Structure:',
//     textEng:
//       '２.Capacitive Sensing:\n' +
//       'The electrodes are constantly generating a small electrostatic field.\n' +
//       'When a finger (or any conductive object) comes close to or touches the surface, it causes a change in the local electrostatic field because the human body can conduct electricity and alter the capacitance.\n' +
//       '  • Capacitance is a property of an electrical system that stores energy in an electric field. The screen works by detecting changes in capacitance.\n' +
//       'Each touch causes a measurable change in capacitance at the point of contact. The controller detects this change, and by comparing signals from the grid, it pinpoints the exact location of the touch.\n' +
//       '\n' +
//       '３.Projected Capacitance:\n' +
//       'In P-Cap systems, the electric field from the electrodes is "projected" beyond the surface, allowing the touch to be detected even without direct contact, like through gloves or thin surfaces.\n' +
//       'The system can detect multiple touch points because each intersection of the grid acts as an independent sensor.\n' +
//       '\n' +
//       '４.Multi-Touch:' +
//       'P-Cap is capable of multi-touch detection because it can track changes in capacitance at multiple points simultaneously.\n' +
//       'This is done by sensing changes across the entire electrode grid and distinguishing between different touches based on the signal strength and pattern.\n' +
//       '\n' +
//       '５.Advantages of Projected Capacitive Touch:\n' +
//       '  • High durability: Works even if the surface is scratched or dirty.\n' +
//       '  • Multi-touch support: Allows gestures like pinch-to-zoom, rotation, etc.\n' +
//       '  • Highly responsive: Provides a fast and accurate touch response.\n' +
//       '  • No calibration required: Stable over time and across various environments\n' +
//       '' +
//       '' +
//       '',
//     describe: 'ServDesignTheory',
//     // link: '',
//     time: '2025/2/13',
//   },
// ]

//
// [
//   {
//      id: 5,
//      image: require('../images/ServiceImg/Design/ServDesign'),
//      alt: 'images/ServiceImg/Design/ServDesignIndustrial.jpg',
//      name: 'Integration/Lamination',
//      title: '觸控電容模型',
//      text:
//        '與自電容測量不同，對於給定的相互感測器佈局，沒有簡單的方法來近似預期的觸控電容。\n' +
//        '平行板近似不適用，因為在這種情況下「板」是 X 和 Y 電極的片段，比觸控蓋小得多。\n' +
//        '使用者的觸摸接觸主要由電極對和指尖之間的邊緣場和點場決定\n' +
//        '\n' +
//        '在設計互電容感測器時，可以優化節點佈局以滿足應用要求，例如：\n' +
//        '\n' +
//        '   • 最大靈敏度\n' +
//        '   • 最佳噪音容忍度\n' +
//        '   • 最佳防水效果\n' +
//        '   • 最小預設感測器電容(某些擷取技術對感測器電容有限制)\n' +
//        '   • 最低功耗\n' +
//        '   • 最小觸控延遲\n' +
//        '\n' +
//        '所有應用程式都需要在這些屬性之間進行權衡，因為實現一個屬性就意味著要損害其他屬性。\n' +
//        '舉例來說，使用高交錯電極可達到最強的靈敏度。\n' +
//        '然而，要實現最小感測器電容，需要 X 和 Y 之間有更大的間距。\n' +
//        '增加 X-Y 分離會減少預設的 X-Y 電容，但也會減少電極之間平行段的長度。\n' +
//        '\n' +
//        '\n',
//      titleEng: 'Touch Capacitance Model',
//      textEng:
//        "Unlike for self-capacitance measurements, there is no simple way to approximate the expected touch capacitance for a given mutual sensor layout.\n" +
//        "The parallel plate approximation is not applicable as the ‘plates’ in this case are segments of the X and Y electrodes, which are much smaller than the touch cover.\n" +
//        "The user’s touch contact is dominated by edge and point fields between the electrode pair and the fingertip." +
//        '\n' +
//        'When designing mutual capacitance sensors, the node layout may be optimized to suit application requirements such as:\n' +
//        '   • Maximum sensitivity\n' +
//        '   • Best noise tolerance\n' +
//        '   • Best water rejection\n' +
//        '   • Minimum default sensor capacitance (some acquisition technologies have a limit on the sensor capacitance)\n' +
//        '   • Minimum power consumption\n' +
//        '   • Minimum touch latency\n' +
//        '\n' +
//        'All applications will require a trade-off between these properties, as achieving one will mean compromising others.\n' +
//        'As an example, the strongest sensitivity is achieved using high interleaving of electrodes.\n' +
//        '\n' +
//        'However, achieving minimum sensor capacitance requires a larger spacing between X and Y.\n' +
//        'Excess sensor capacitance increases acquisition time and power consumption.\n' +
//        'Increasing X-Y separation reduces default X-Y capacitance, but it also reduces the lengths of parallel segments between the electrodes.\n' +
//        '\n' +
//        '',
//      describe: '',
//      link: '',
//      time: '2025/2/16',
//    },
// ]